import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Site} from '../../pages/user-management/site/site.model';
import {UserInfoService} from '../user-info.service';

export interface SiteRequestParam {
    id: number;
    name: string;
    regionId: number;
    siteIds: any[];
    regionIds: any[];
    startDate: any;
    endDate: any;
    orderBy: number;
}

@Injectable()
export class SiteService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig, private userInfoService: UserInfoService) {
    }

    // fetch All Site
    getAllSite(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const vendorListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        me.apiRequest.get(this.appConfig.site_url, params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    regionId: `${v.regionId}`
                });
            });

            const coldObj = Object.assign({}, jsonResp, {
                data: items
            });
            vendorListSubject.next(coldObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return vendorListSubject;
    }

    // save site
    save(site: Site): Observable<any> {
        const me = this;

        const bodyData: SiteRequestParam = <SiteRequestParam>{
            'regionId': site.regionId,
            'name': site.name

        };

        const siteDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.site_url, bodyData)
            .subscribe(jsonResp => {
                    let siteInfoReturn: SiteRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const site: Site = jsonResp.data[0];

                        siteInfoReturn = <SiteRequestParam>{
                            'name': site.name,
                            'regionId': site.regionId
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    siteDataSubject.next(siteInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return siteDataSubject;
    }

    // update site
    update(site: Site, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': site.id,
            'name': site.name,
            'regionId': site.regionId
        };

        const siteDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.site_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let siteInfoReturn: SiteRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Site = jsonResp.data[0];
                        siteInfoReturn = <SiteRequestParam>{
                            'id': cc.id,
                            'regionId': cc.regionId,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    siteDataSubject.next(siteInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return siteDataSubject;
    }

    deleteSite(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.site_url + '/' + id);
    }

    getAvgDataBasedOnSiteId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'siteIds': site.siteIds,
            'startDate': site.startDate,
            'endDate': site.endDate

        };

    //    const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/profile-type', bodyData);

       // return userDataSubject;
    }

    getEscalationLevel(site: Site): Observable<any> {
        const me = this;
        const bodyData = {
            'siteIds': site.siteIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };

        //  const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/escalation-levels', bodyData);
    }
    getEscalationLevelByRegionId(site: Site): Observable<any> {
        const me = this;
        const bodyData = {
            'regionIds': site.regionIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };

        //  const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/escalation-levels', bodyData);
    }

    getAvgDataBasedOnRegionId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'regionIds': site.regionIds,
            'startDate': site.startDate,
            'endDate': site.endDate

        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/profile-type', bodyData);

        // return userDataSubject;
    }



    getSiteRankingBasedOnRegionId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'regionIds': site.regionIds,
          'orderBy': site.orderBy,
            'startDate': site.startDate,
            'endDate': site.endDate

        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/compliance/order-by', bodyData);
    }
    getSiteByRegion(site: Site) {
        const bodyData = {
            'regionIds': site.regionIds,
        };
        return this.apiRequest.post(this.appConfig.region_url + '/sites', bodyData);
    }
getColdStoreByRegion(site: Site) {
    const bodyData = {
        'regionIds': site.regionIds,
    };
    return this.apiRequest.post(this.appConfig.region_url + '/sites', bodyData);
}

    // monthly data line chart

    getMonthlyDataByRegionId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'regionIds': site.regionIds,
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/monthly/compliance', bodyData);

        // return userDataSubject;
    }


    getMonthlyDataBySiteId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'siteIds': site.siteIds,
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/monthly/compliance', bodyData);

        // return userDataSubject;
    }
    getAvgMonthValueBySiteId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'siteIds': site.siteIds,
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/monthly/compliance', bodyData);

        // return userDataSubject;
    }
    getAvgMonthValueByRegionId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'regionIds': site.regionIds,
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/monthly/compliance', bodyData);

        // return userDataSubject;
    }

    downloadExcelFileBySiteId(site: Site): Observable<any> {
        const me = this;

        const bodyData = {
            'regionIds': site.siteIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };
        return Observable.create(observer => {

            const xhr = new XMLHttpRequest();
            // xhr.open('POST', this.appConfig.site_url + '/cold-stores/compliance/order-by/excel' , true) ;
            xhr.open('POST', this.appConfig.region_url + '/cold-stores/compliance/order-by/excel' , true) ;
            xhr.setRequestHeader('Content-type', 'application/json');

            const token = this.userInfoService.getStoredToken();
            if (token !== null) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            }
            xhr.responseType = 'blob';

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const contentType = 'application/vnd.ms-excel';
                        const blob = new Blob([xhr.response], {type: contentType});
                        observer.next(blob);
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            }
            console.log('dff', JSON.stringify(bodyData));
            xhr.send(JSON.stringify(bodyData));

        });
    }

    getDownTimeByRegionId(site: Site) {
        const me = this;

        const bodyData = {
            'regionIds': site.regionIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.region_url + '/cold-stores/profile-type/downtime', bodyData);

        // return userDataSubject;
    }

    getDownTimeBySiteId(site: Site) {
        const me = this;

        const bodyData = {
            'siteIds': site.siteIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };

        const userDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/profile-type/downtime', bodyData);

        // return userDataSubject;
    }

    getCompliancePercentBySiteId(site: Site) {
        const me = this;
        const bodyData = {
            'siteIds': site.siteIds,
            'startDate': site.startDate,
            'endDate': site.endDate
        };
        return me.apiRequest.post(this.appConfig.site_url + '/cold-stores/compliance', bodyData);
    }

}
